import React, { useState, useEffect } from "react";
import * as bootstrap from 'bootstrap';

import info_button from "../../assets/images/svg/info_button.svg";

const RadioQuestion = ({ question, value = null, onChange }) => {

    useEffect(() => {
        const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        tooltipTriggerList.forEach(el => new bootstrap.Tooltip(el));
    }, []);

    const [cols, setCols] = useState("");
    
    return (
        <div className="question radio-question py-4 py-lg-5">
            <div className="chat-message">
                <h4 className="m-0" dangerouslySetInnerHTML={{ __html: question.label +
                                            (question.optional !== 1 ? "" : "") }}/>
                {question.sublabel && (<p className="mb-0 mt-1" dangerouslySetInnerHTML={{ __html: question.sublabel }}/>)}
            </div>
            <div className="chat-answer radio-list">
                <div className="row justify-content-start">
                    {question.answers.map((option, index) => {
                        
                        // antes do return, dentro do map:
                        const keyOf = (opt) => (opt.value ?? opt.ans_id); // se não houver value, usa ans_id
                        const groupName = `radio-${question.sym_id}`;
                        const rawKey = keyOf(option);

                        // respondeu? (não confundir "0" com vazio)
                        const hasAnswer = value !== null && value !== undefined && value !== "";

                        // compare sempre como string (estável para 0 / "0")
                        const isChecked = hasAnswer && String(value) === String(rawKey);


                        if(cols === ""){
                            setCols(option.label && option.label.length < 10 ? 'col-lg-4' : option.explain ? 'col-lg-12' : 'col-lg-6');
                        }
                        return (
                            <div className={`col-12 ${cols} pt-4 align-items-center d-flex`} key={index}>
                                    <input
                                        id={`${groupName}-${rawKey}`}
                                        type="radio"
                                        name={groupName}
                                        value={String(rawKey)}                 // SEMPRE string no DOM
                                        checked={isChecked}                 // compara em string (não quebra no 0)
                                        onChange={(e) => {
                                            // devolve string pura; o pai NÃO perde o "0"
                                            onChange(e.target.value);
                                        }}
                                        className="form-check-input"
                                    />
                                    <label htmlFor={`${groupName}-${rawKey}`} className="form-check-label">
                                        {option.label}
                                        {option.explain && (<button type="button" className="info_button" data-bs-toggle="tooltip" data-bs-offset="0,0" data-bs-placement="right" data-bs-html="true" title={option.explain}>
                                            <img src={info_button} alt="info_button" style={{'display':'flex'}} />
                                        </button>)}
                                    </label>
                                    
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    );
};

export default RadioQuestion;
